import { ReactNode } from 'react';
import { Activity } from 'apollo/types';
import { FormFields } from 'components/UI/Form/types';
import * as placeTexts from '../../../../assets/texts/placeConfiguration';
import * as grillTexts from '../../../../assets/texts/grillConfiguration';

const grillFormFields = (
  isCreation: boolean,
  editableRow?: Activity,
  uploadElements?: ReactNode,
  uploadElement?: ReactNode
): FormFields[] => {
  const formFields = [
    {
      name: 'name',
      label: grillTexts.grillName,
      type: 'text',
      initialValue: editableRow?.name || '',
      rules: [{ required: isCreation }],
    },
    {
      name: 'mainDescription',
      label: placeTexts.description,
      type: 'textarea',
      initialValue: editableRow?.place?.mainDescription || '',
      rules: [{ required: isCreation }],
    },
    {
      name: 'secondaryDescription',
      label: placeTexts.secondaryDescription,
      type: 'textarea',
      initialValue: editableRow?.place?.secondaryDescription || '',
      rules: [{ required: isCreation }],
    },
  ];

  if (isCreation) {
    return formFields;
  }
  return [
    ...formFields,
    {
      name: 'placeMainImage',
      label: placeTexts.placeMainImage,
      type: 'images',
      uploadelement: uploadElement,
      rules: [{ required: false }],
    },
    {
      name: 'images',
      label: 'Fotos',
      type: 'images',
      uploadelement: uploadElements,
      rules: [{ required: false }],
    },
  ];
};

export default grillFormFields;
